var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('tab-title',{attrs:{"tabList":_vm.tabList,"url":"personservice"}}),_c('div',{staticClass:"router-section"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }